export interface ReiSiftAccount {
  uuid: string;
  name: string;
}

export interface ReiSiftAccountSearchParams {
  account_id: number;
}

export interface VerifyReiSiftAccessTokenResponse {
  uuid: string;
}

export interface VerifyReisiftAccessTokenParams {
  account_id: number;
  access_token: string;
}

export interface ReiSiftUploadFilePayload {
  file_id: string;
  account_id: number;
}

export interface ReiSiftPropertyPayload {
  lead_id: number;
  account_id: number;
}

export enum ReiSiftUploadStatus {
  Pending = "pending",
  Success = "success",
  Error = "error",
}

export interface ReiSiftUploadDetails {
  file_id: string;
  status: ReiSiftUploadStatus;
  created_at: Date;
}
